import React from 'react';
import { FadeIn } from './FadeIn';
const weeks = [{
  num: 1,
  title: 'Illumination',
  desc: 'You map your exact triggers. Not to avoid them — to understand precisely what activates them and why. When you see the mechanism clearly, it loses its power.'
}, {
  num: 2,
  title: 'The Silence',
  desc: 'The urge starts to feel different. Not stronger, not weaker — different. Like something that belongs to a previous version of you.'
}, {
  num: 3,
  title: 'The New Baseline',
  desc: 'You are not resisting anything. There is nothing left to resist. The brain already has a new reference point.'
}];
export const WeekCards: React.FC = () => {
  return <div className="my-16 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-211">
      {weeks.map((week, idx) => <FadeIn key={week.num} delay={idx * 0.1} data-id="element-212">
          <div className="bg-white border border-navy/10 p-8 rounded-sm h-full flex flex-col shadow-sm hover:shadow-md transition-shadow" data-id="element-213">
            <div className="text-amber font-sans font-bold text-sm tracking-widest uppercase mb-2" data-id="element-214">
              Week {week.num}
            </div>
            <h3 className="text-xl font-serif font-bold text-navy mb-4" data-id="element-215">
              {week.title}
            </h3>
            <p className="text-navy/80 font-serif leading-relaxed text-base flex-grow" data-id="element-216">
              {week.desc}
            </p>
          </div>
        </FadeIn>)}
    </div>;
};